import React, { useState, useEffect } from 'react';

import { MenuItem, Select } from 'shell/components';

const MultiSelectQuestion = ({ id, question, itemList, defaultItem, review, handleSelected }) => {
    const [selectedItems, setSelectedItems] = useState([]);

    const handleSelectedItems = (e) => {
        setSelectedItems(e.target.value);
        handleSelected(e.target.value.map((id) => itemList.find(({ key }) => key === id)));
    };

    useEffect(() => {
        if (defaultItem) setSelectedItems(defaultItem.map(({ key }) => key));
    }, [defaultItem]);

    return (
        <Select
            disabled={review}
            label={question}
            labelId={id}
            multiple
            value={selectedItems}
            onChange={handleSelectedItems}
        >
            {itemList.map(({ key, value }) => (
                <MenuItem key={key} value={key}>
                    {value}
                </MenuItem>
            ))}
        </Select>
    );
};

export default MultiSelectQuestion;
